import { centerNode } from "@/components/FlowSheetEditor/utils"
import { AimOutlined, DeleteOutlined } from "@ant-design/icons"
import { Edge, Node } from "@antv/x6"
import { useGraphInstance } from "@antv/xflow"
import { Button, Input, Popconfirm, Space, Table } from "antd"
import { useMemo, useState } from "react"

export enum TableType {
  Stream,
  Node
}

interface UnitTableProps {
  type: TableType
  units: Node[] | Edge[]
  reload: () => void
}

export const UnitTable = (props: UnitTableProps) => {
  const {type, units, reload} = props;
  const graph = useGraphInstance()
  const [text, setText] = useState('')

  const data = useMemo(() => {
    return units.map(cell => {
      const cellData = cell.getData();
      return {
        id: cell.id,
        tag: cellData.tag,
      }
    })
  }, [type, units])

  const filteredData = (() => {
    return data.filter(item => (item.tag as string).toLowerCase().includes(text))
  })()

  const onDelete = (id: string) => {
    graph?.removeCell(id)
    reload()
  }

  const activeItem = (id: string) => {
    const node = graph?.getCellById(id)
    if (node) {
      centerNode(graph!, node as Node)
    }
  }

  const columns = [
    {
      title: 'Index',
      dataIndex: 'id',
      render: (_, record, index) => {
        return index + 1
      }
    },
    {
      title: 'Tag',
      dataIndex: 'tag',
      key: 'tag',
    },
    {
      title: 'Actions',
      render: (item) => {
        return <Space>
          <Button icon={<AimOutlined />} title="Show" onClick={() => activeItem(item.id)} />
          <Popconfirm
            title={`Delete The ${type === TableType.Node ? 'Equipment' : 'Stream'}`}
            description={`Are you sure to delete ${item.tag}?`}
            onConfirm={() => onDelete(item.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button size="small" icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      }
    },
  ];

  return <div>
    <div className="p-1">
      <Input placeholder="Filter by tag" onChange={(e) => setText(e.target.value.toLowerCase())} />
    </div>
    <Table dataSource={filteredData} columns={columns} size="small" pagination={{hideOnSinglePage: true, pageSize: 20}} />
  </div>
}